import { PluginLoader } from './plugins';
import { Geetest } from './plugins/geetest';
import { Qqcaptcha } from './plugins/qqcaptcha';
import { Recaptcha } from './plugins/recaptcha';
import type { CaptchaOptions, CaptchaShowResult, ShowOptions } from './typings';
import { isMobile } from './utils';

export * from './typings';
export * from './utils';

export type CaptchaInstance = Recaptcha | Geetest | Qqcaptcha;

export class BoneCaptcha {
  [x: string]: any;
  currentIndex: number;
  captchas: CaptchaInstance[];
  lang: string | undefined;
  options: CaptchaOptions;
  pluginLoader: PluginLoader;

  constructor(options: CaptchaOptions) {
    this.currentIndex = 0;
    this.captchas = [];
    this.lang = options.lang || 'en';
    this.options = options;
    this.pluginLoader = new PluginLoader(options);
    this.captchas = this.pluginLoader.plugins;
  }

  /**
   * Whether current captcha can resize
   * only for recaptcha in mobile
   *
   * @return {*}
   * @memberof Captcha
   */
  isCanResize() {
    const currentCaptcha = this.current();
    return currentCaptcha.key === 'recaptcha';
  }

  resize(el: HTMLElement | string | null) {
    const current = this.current();
    current.resize(el);
  }

  setLang(lang: string) {
    this.lang = lang;

    const current = this.current();
    current.setLang(lang);
  }

  initialize(options: ShowOptions) {
    const currentCaptcha = this.current();
    if (currentCaptcha && currentCaptcha.initialize) {
      setTimeout(() => {
        currentCaptcha.initialize(options);
      }, 100);
    }
  }

  async displayNext(options: ShowOptions): Promise<CaptchaShowResult> {
    this.currentIndex += 1;
    const res = await this.show(options);
    return res;
  }

  async show(options: ShowOptions): Promise<CaptchaShowResult> {
    const currentCaptcha = this.current();

    if (currentCaptcha) {
      try {
        const res = await currentCaptcha.show(options);
        if (!res) {
          return this.displayNext(options);
        }
        if (isMobile()) {
          this.resize(options.id);
        }
        return {
          success: true,
          type: currentCaptcha.key,
        };
      } catch (e) {
        console.warn(`[${currentCaptcha.key}] ${e}`);
        return this.displayNext(options);
      }
    } else {
      if (this.currentIndex === this.captchas.length) {
        this.reset();
      }
      return {
        success: false,
      };
    }
  }

  current(): CaptchaInstance {
    return this.captchas[this.currentIndex];
  }

  refresh() {
    const current = this.current();
    if (current) {
      current.refresh();
    }
  }

  reset() {
    this.currentIndex = 0;
    this.refresh();
  }

  onMounted(options: ShowOptions) {
    // for recaptcha hide mode need
    if (this.options.invisibleMode) {
      this.initialize(options);
    } else {
      this.show(options);
    }
  }

  onBeforeUnmount() {
    this.reset();
  }
}
